import React from 'react';

import { SimpleBarChart } from '@magoosh/lib/charts';

import StatisticData from '../statistic_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  examName: string;
  filters: any;
}

const PerformanceByDifficultyChart: React.FC<Props> = (props) => {
  const loadingPlaceholder = (
    <SimpleBarChart
      colorPalette={{ dark: colors.gray85, light: colors.grayLightest }}
      data={[
        {
          name: 'Easy',
          data: [
            { color: colors.gray85, label: 'Correct', value: 60 },
            { color: colors.grayLightest, label: 'Incorrect', value: 40 }
          ]
        },
        {
          name: 'Medium',
          data: [
            { color: colors.gray85, label: 'Correct', value: 40 },
            { color: colors.grayLightest, label: 'Incorrect', value: 60 }
          ]
        },
        {
          name: 'Hard',
          data: [
            { color: colors.gray85, label: 'Correct', value: 20 },
            { color: colors.grayLightest, label: 'Incorrect', value: 80 }
          ]
        },
        {
          name: 'Very Hard',
          data: [
            { color: colors.gray85, label: 'Correct', value: 0 },
            { color: colors.grayLightest, label: 'Incorrect', value: 100 }
          ]
        }
      ]}
    />
  );

  const formatStatisticData = (statisticData) => {
    return statisticData.map((series) => (
      {
        ...series,
        data: series.data.map((datum) => {
          const formattedData = {
            label: datum.name,
            value: datum.value
          } as any;

          const predeterminedColor = {
            'Correct': colors.dataDarkPurple,
            'Incorrect': colors.dataMutedPurple,
            'Not Graded': colors.grayLighter
          }[datum.name];

          if (predeterminedColor) {
            formattedData.color = predeterminedColor;
          }

          return formattedData;
        })
      }
    ));
  };

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        formatDataFn={formatStatisticData}
        name="performance_by_difficulty"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <SimpleBarChart
          colorPalette={{ dark: colors.dataDarkPurple, light: colors.dataMutedPurple }}
        />
      </StatisticData>
    );
  }
};

export default PerformanceByDifficultyChart;
